import axios from "axios"
import toast from "react-hot-toast"
import { removeUserSession, removeTemporarySession } from "../AuthService"

// global lock
let isLoggingOut = false

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => {
      const message = response?.data?.errorMessage

      const isSessionExpired =
        message === "Your session expired, please login" ||
        message === "jwt expired" ||
        message === "invalid token"

      if (isSessionExpired) {

        // already processing logout
        if (isLoggingOut) {
          return response
        }

        isLoggingOut = true

        // remove all previous toasts
        toast.dismiss()

        // show only one toast
        // toast.error(
        //   "Session expired. Please login again.",
        //   {
        //     id: "session-expired"
        //   }
        // )

        removeUserSession()
        removeTemporarySession()

        localStorage.clear()
        sessionStorage.clear()

        setTimeout(() => {
          if (window.location.pathname !== "/login") {
            window.location.href = "/login"
          }
        }, 800)
      }

      return response
    },

    (error) => {
      return Promise.reject(error)
    }
  )
}

export default setupAxiosInterceptors